__turbopack_context__.v({
  "homeBannerContainer": "home-module-sass-module__zJnmqW__homeBannerContainer",
  "homePage": "home-module-sass-module__zJnmqW__homePage",
});
